import './bootstrap';
import './echo';
import './lms/notifications';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';

window.Alpine = Alpine;

// Plugins used by the modern design-system components:
//   persist  — sidebar collapsed state, etc.
//   focus    — modal focus-trapping (x-trap)
//   collapse — accordions / sidebar submenus (x-collapse)
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);

// Global toast store consumed by <x-ui.toast-container />.
// Trigger from anywhere: Alpine.store('toasts').success('Saved!') or $store.toasts.error('...')
Alpine.store('toasts', {
    items: [],
    _id: 0,
    add(message, type = 'info', duration = 4000) {
        const id = ++this._id;
        this.items.push({ id, message, type, duration });
        if (duration > 0) {
            setTimeout(() => this.remove(id), duration);
        }
        return id;
    },
    success(m, d) { return this.add(m, 'success', d); },
    error(m, d) { return this.add(m, 'error', d ?? 6000); },
    warning(m, d) { return this.add(m, 'warning', d); },
    info(m, d) { return this.add(m, 'info', d); },
    remove(id) { this.items = this.items.filter((t) => t.id !== id); },
});

// Let server code / inline scripts raise a toast via a window event:
//   window.dispatchEvent(new CustomEvent('toast', { detail: { message, type } }))
window.addEventListener('toast', (e) => {
    const d = e.detail || {};
    Alpine.store('toasts').add(d.message || '', d.type || 'info', d.duration);
});

Alpine.start();
